import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import ProductConfigurator from "../product-configurator";
import { GetProductModelResource } from "@/api/generated-api";
import Picture from "@/components/ui/picture";

interface ProductShowcaseProps {
  product: GetProductModelResource;
}

const ProductShowcase = ({ product }: ProductShowcaseProps) => {
  return (
    <>
      <section className={S.showcase}>
        <Container className={S.container}>
          <div className={S.media}>
            <Picture image={product.half_banner_image} className={S.mediaImage} />
          </div>

          <ProductConfigurator product={product} />
        </Container>
      </section>

      <Picture image={product.full_banner_image} width={3200} height={1800} className={S.closeupImage} />
    </>
  );
};

export default ProductShowcase;
